import "./Chart.scss"
import React, { PropTypes } from "react"
import {
  ResponsiveContainer,
  ComposedChart,
  Area,
  Bar,
  Tooltip,
  Line,
  XAxis,
  ReferenceArea,
  ReferenceDot
} from "recharts"
import { UNSTUCK_BLUE } from "./../constants"
import {
  getChartData,
  getTopStage,
  getStageIndex
} from "../assess/survey-utils"

const AverageScoreTooltip = ({ active, payload }) => {
  if (!active) {
    return null
  }
  const { label, average } = payload[1].payload
  return (
    <div className="Chart_tooltip">
      <p>
        {Math.round(average / 70 * 100)}
        <span>%</span> Average {label} phase
      </p>
    </div>
  )
}

const Chart = ({
  questions,
  side,
  bars,
  averageScoreTooltip,
  hideTopStage
}) => {
  if (!questions || questions.length < 49) {
    return null
  }
  const topStage = getTopStage(questions, side)
  const stageIndex = getStageIndex(topStage)
  const chartData = getChartData(questions, stageIndex)
  return (
    <div className="Chart">
      <ResponsiveContainer width="100%" height={400}>
        <ComposedChart
          data={chartData}
          margin={{ top: 20, right: 20, left: 20, bottom: 20 }}
        >
          <Area
            type="monotone"
            dataKey="base"
            fill="rgba(0,0,0,0.05)"
            activeDot={false}
            stroke="none"
            isAnimationActive={false}
          />
          {!bars && (
            <Area
              type="monotone"
              dataKey="score"
              fill="rgba(0,0,0,0.1)"
              activeDot={false}
              stroke="none"
              isAnimationActive={false}
              connectNulls={true}
            />
          )}
          {bars && <Bar dataKey="value" fill="rgba(0,0,0,0.05)" barSize={5} />}

          {!hideTopStage && (
            <Line
              dataKey="phase"
              type="monotone"
              strokeWidth={2}
              stroke={UNSTUCK_BLUE}
              dot={false}
              isAnimationActive={true}
            />
          )}
          {!hideTopStage && (
            <ReferenceDot
              x={stageIndex}
              y={chartData[stageIndex].base}
              r={5}
              stroke="none"
              fill={UNSTUCK_BLUE}
            />
          )}
          <XAxis dataKey="label" tickLine={false} interval={7} />
          {averageScoreTooltip &&
          false && <Tooltip cursor={false} content={<AverageScoreTooltip />} />}
          <ReferenceArea
            x1={stageIndex - 3}
            x2={stageIndex + 3}
            y1={0}
            y2={10}
            fill="rgba(0, 178, 190, 0.5)"
          />
        </ComposedChart>
      </ResponsiveContainer>
    </div>
  )
}

Chart.displayName = "Chart"

Chart.propTypes = {
  questions: PropTypes.arrayOf(PropTypes.number).isRequired,
  side: PropTypes.oneOf(["left", "right"])
}

export default Chart



// WEBPACK FOOTER //
// ./src/lib/Chart.js